import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { getAllEvaUsers } from 'services/userServices';

const UserDropdown = ({ selectedOptions, handleChange, isMulti = true, showLogin = false, isClearable = false }) => {
  const [users, setUsers] = useState([]);
  const isMounted = useRef(null);

  const options = showLogin
    ? users.map(u => ({
        ...u,
        label: u.name + (u.login ? ` (${u.login})` : '')
      }))
    : users;

  useEffect(() => {
    isMounted.current = true;
    const controller = new AbortController();

    getAllEvaUsers(controller.signal)
      .then(res => {
        if (!isMounted.current) return null;

        if (res?.length) setUsers(res);
      })
      .catch(err => {
        console.log('Error in user fetch', err);
      });

    return () => {
      isMounted.current = false;
      controller.abort();
    };
  }, []);

  return (
    <Select
      isMulti={isMulti}
      isClearable={isClearable}
      name="users"
      options={options}
      value={
        typeof selectedOptions === 'number'
          ? options?.find(x => x.value === selectedOptions)
          : selectedOptions
      }
      onChange={selected => handleChange(selected)}
      classNamePrefix="react-select"
      placeholder="Select a user from the list..."
    />
  );
};

UserDropdown.propTypes = {
  selectedOptions: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  handleChange: PropTypes.func,
  isMulti: PropTypes.bool,
  showLogin: PropTypes.bool,
  isClearable: PropTypes.bool
};

export default UserDropdown;
